/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Operator_FilterInputs */

const fr_network_vehicle_operator_filter = /** @type {(inputs: Network_Vehicle_Operator_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opérateur`)
};

const en_network_vehicle_operator_filter = /** @type {(inputs: Network_Vehicle_Operator_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operator`)
};

/**
* | output |
* | --- |
* | "Operator" |
*
* @param {Network_Vehicle_Operator_FilterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_operator_filter = /** @type {((inputs?: Network_Vehicle_Operator_FilterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Operator_FilterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_operator_filter(inputs)
	return en_network_vehicle_operator_filter(inputs)
});